import { useCallback } from "react";
import { logout as apiLogout } from "../api/auth";
import { resetPrefsCache } from "../lib/userPrefs";
import { useAuthStore } from "../state/authStore";
export function useLogout() {
    const clearAuth = useAuthStore((s) => s.clear);
    return useCallback(async () => {
        try {
            await apiLogout();
        }
        catch { /* локально всё равно выходим */ }
        clearAuth();
        resetPrefsCache();
        window.location.assign("/login");
    }, [clearAuth]);
}
